import React, { useEffect, useState } from 'react';
import { StepperEnum, useWizardStepperContext } from '../../contexts/useWizardStepper.context';
import { Button, Grid } from '@mui/material';
import CallOutComponent from '../callout/callout.component';
import MuiIcon from '../../../../../shared/styles/mui/helpers/mui-icon.helper';
import useWizardReportDataContext from '../../contexts/useWizardReportData.context';


/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Dec/01/2024
 */
export default function WizardFooterComponent() {

    const { activeStep, activeStepIndex, handleBack, handleNext, invalidSteps } = useWizardStepperContext();
    const { pivotData, wizardData, isNewReport } = useWizardReportDataContext();

    const [preventNext, setPreventNext] = useState(false);
    const [canSkip, setCanSkip] = useState(false);
    const [finalStep, setFinalStep] = useState(false);

    useEffect(() => {
        setPreventNext(invalidSteps.includes(activeStepIndex));
    }, [invalidSteps, activeStepIndex]);

    useEffect(() => {
        setFinalStep(
            (activeStep === StepperEnum.Create
                || activeStep === StepperEnum.Update)
        );
    }, [activeStep])

    useEffect(() => {
        const hasNoFilterCriterias = !wizardData.reportSpecification.filterCriterias?.length;
        const hasNoPivot = !pivotData?.parentColumn;
        setCanSkip(
            (activeStep === StepperEnum.Filters &&
                hasNoFilterCriterias)
            || (activeStep === StepperEnum.Pivot &&
                hasNoPivot)
        );
    }, [activeStep, pivotData?.parentColumn, wizardData.reportSpecification.filterCriterias])


    return (
        <Grid container justifyContent='center'>

            {/* Back-Button */}
            <Grid item xs={1}>
                <Button onClick={handleBack} disabled={activeStepIndex === 0} startIcon={MuiIcon.ARROW_CIRCLE_LEFT()}>
                    Back
                </Button>
            </Grid>

            <Grid item xs={1}>
            </Grid>

            {/* Warning-Message */}
            <Grid item xs={8}>
                {preventNext && <CallOutComponent type={'error'} text="Please complete this Step to proceed." />}
                {canSkip && <CallOutComponent type={'special'} text="You may skip this step." />}
                {/* {finalStep && <CallOutComponent type={'info'}
                    text={`You are almost ready to ${isNewReport ? 'Create' : 'Update'} the report. Please take a moment to review your changes.`} />} */}
            </Grid>

            {/* Skip Button */}
            <Grid container item xs={1} justifyContent="flex-end" alignItems="center">
                {canSkip &&
                    <Button variant='contained' color='info' onClick={handleNext} disabled={preventNext} endIcon={MuiIcon.SKIP()}>
                        Skip
                    </Button>
                }
            </Grid>

            {/* Next/Finish-Button */}
            <Grid container item xs={1} justifyContent="flex-end" alignItems="center">
                {finalStep ?

                    // Finish Button
                    <Button color='success' variant='contained' onClick={handleNext} disabled={preventNext}
                        endIcon={MuiIcon.FINISH()}>
                        Finish
                    </Button>
                    :
                    // Next Button
                    <Button onClick={handleNext} disabled={preventNext} endIcon={MuiIcon.ARROW_CIRCLE_RIGHT()}>
                        Next
                    </Button>
                }
            </Grid>

        </Grid >
    );
}